import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import styled from "styled-components";
import { Box, SpanStyled } from "../../styled/Elements";
import { useTranslation } from "react-i18next";

const OTPInputField = forwardRef(({ setValue, register }, ref) => {
  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(90);
  const [expired, setExpired] = useState(false);
  const firstInputRef = useRef(null);

  const inputs = Array.from({ length: 6 }, (_, i) => i);

  const handleChange = (e, index) => {
    const value = e.target.value;

    if (isNaN(value)) return;

    setValue(`otp-${index}`, value);

    if (e.target.nextSibling) {
      e.target.nextSibling.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const value = e.target.value;

      if (value) {
        setValue(`otp-${index}`, "");
        e.target.value = "";
        if (e.target.previousSibling) {
          e.target.previousSibling.focus();
        }
      } else {
        if (e.target.previousSibling) {
          e.target.previousSibling.focus();
        }
      }
    }
  };

  useImperativeHandle(ref, () => ({
    resetTimer: () => {
      setSeconds(90);
      setExpired(false);
      clearOtpFields();
    },
  }));

  const clearOtpFields = () => {
    inputs.forEach((_, index) => setValue(`otp-${index}`, "")); // Clear all inputs
  };
  useEffect(() => {
    firstInputRef.current?.focus();
  }, []);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setInterval(() => {
        setSeconds(seconds - 1);
      }, 1000);
      return () => clearInterval(timer);
    } else {
      setExpired(true);
    }
  }, [seconds]);

  return (
    <Box>
      <OtpContainer>
        {inputs.map((_, index) => (
          <OtpInput
            key={index}
            ref={index === 0 ? firstInputRef : null}
            type="text"
            maxLength="1"
            {...register(`otp-${index}`)}
            onInput={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            disabled={expired}
          />
        ))}
      </OtpContainer>
      <TimerContainer>
        {expired ? (
          <SpanStyled className="pt-2" color="var(--text)">
            {t("time_up_please_request_new_code")}
          </SpanStyled>
        ) : (
          <>
            <SpanStyled
              color="var(--themeColor)"
              bg="var(--white)"
              className="count-num pt-2"
            >
              {Math.floor(seconds / 60)
                .toString()
                .padStart(2, "0")}
            </SpanStyled>
            <span style={{ color: "var(--themeColor)" }}>:</span>
            <SpanStyled
              color="var(--themeColor)"
              bg="var(--white)"
              className="count-num pt-2"
            >
              {Math.floor(seconds % 60)
                .toString()
                .padStart(2, "0")}
            </SpanStyled>
          </>
        )}
      </TimerContainer>
    </Box>
  );
});

export default OTPInputField;

const TimerContainer = styled.div`
  margin-bottom: 20px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  .count-num {
    /* border: 1px solid var(--border); */
    /* border-radius: 6px; */
    background-color: transparent;
    background: transparent;
  }
`;

const OtpInput = styled.input`
  width: 100%;
  height: 70px;
  margin: 0 10px;
  font-size: 24px;
  color: var(--text);
  text-align: center;
  border: 1px solid var(--borderLight);
  border-radius: 8px;
  outline: none;
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
  &:focus {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-color: var(--border);
  }
  &:disabled {
    /* background-color: var(--bgSecondary); */
  }
`;

const OtpContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
